import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#DC2625",
        accent: "#E0E0E0",
      },
    },
    options: { customProperties: true },
  },
});
